import React, { Component } from 'react';
import ReactTable from 'Common/ReactTableWrapper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { TransactionDetailsEnum } from 'Common/FieldEnum';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { dateSortMethod, numericSortMethod } from 'Common/GridHelper';

class TransactionDetailTable extends Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        Header: 'Site',
        accessor: TransactionDetailsEnum.Site,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Transaction',
        accessor: TransactionDetailsEnum.Transaction,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Date',
        accessor: TransactionDetailsEnum.TransactionDT,
        sortMethod: dateSortMethod,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Purchase Qty',
        accessor: TransactionDetailsEnum.PrimaryQty,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Unit',
        accessor: TransactionDetailsEnum.Unit,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Purchase Price',
        accessor: TransactionDetailsEnum.PrimaryPrice,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
        sortMethod: numericSortMethod,
      },
      {
        Header: 'Pack Qty',
        accessor: TransactionDetailsEnum.SecondaryQty,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Pack Unit',
        accessor: TransactionDetailsEnum.SecondaryUnit,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Sec. Price',
        accessor: TransactionDetailsEnum.SecondaryPrice,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
        sortMethod: numericSortMethod,
      },
      {
        Header: 'Distributor',
        accessor: TransactionDetailsEnum.Vendor,
        ...ReactTableWrapperColumnProperties,
      },
      {
        width: 50,
        sortable: false,
      },
    ];
  }

  render() {
    const {
      transactionDetailsData,
      fetchingTransaction,
      resetPageOnDataChange,
      onResetPageOnDataChange,
    } = this.props;

    return (
      <ReactTable
        reactTableRef={this.reactTable}
        loading={fetchingTransaction}
        defaultPageSize={20}
        showPageSizeOptions={true}
        minRows={5}
        data={transactionDetailsData}
        noDataText={fetchingTransaction ? '' : 'No items found'}
        resizable={false}
        className="-striped -highlight modalGrid"
        columns={this.columns}
        draggableColumns={true}
        showHideColumn={true}
        menu={'hasCogs'}
        saveState={{
          tableName: TableNamesEnum.TRANSACTION_DETAIL_TABLE,
        }}
        resetPageOnDataChange={resetPageOnDataChange}
        onResetPageOnDataChange={onResetPageOnDataChange}
        gridName={GridEnum.INV_TransactionDetails_View}
      />
    );
  }
}

export { TransactionDetailTable };



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/components/tables/TransactionDetailTable.js